import { useTranslation } from "react-i18next";
import * as S from "./style";

const Home = () => {
  const { t } = useTranslation("home");

  return (
    <S.Container>
      <S.Text>{t("hello")}</S.Text>
      <S.BigText>{t("myName")}</S.BigText>
      <S.Role>{t("devInfo")}</S.Role>
      <S.Location>{t("locationRemote")}</S.Location>
    </S.Container>
  );
};

export default Home;
